import type { ControlProps, RankedTester } from "@jsonforms/core";
import { and, isBooleanControl, optionIs, rankWith } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import {
  Field,
  FieldLabel,
  FieldDescription,
  FieldError,
  FieldContent,
} from "@/components/ui/field";
import { ShadcnSwitch } from "../shadcn-controls/ShadcnSwitch";
import { useTouched } from "../hooks/useTouched";

export const ShadcnBooleanToggleControl = ({
  data,
  visible,
  label,
  id,
  enabled,
  uischema,
  schema,
  rootSchema,
  handleChange,
  errors,
  path,
  config,
  description,
  required,
}: ControlProps) => {
  const { showErrors, markTouched } = useTouched(data);
  const isValid = errors.length === 0;

  if (!visible) {
    return null;
  }

  const handleChangeWithTouch = (path: string, value: boolean | undefined) => {
    markTouched();
    handleChange(path, value);
  };

  return (
    <Field
      orientation="horizontal"
      data-invalid={(!isValid && showErrors) || undefined}
      data-disabled={!enabled || undefined}
    >
      <ShadcnSwitch
        id={`${id}-input`}
        data={data}
        enabled={enabled}
        visible={visible}
        path={path}
        uischema={uischema}
        schema={schema}
        rootSchema={rootSchema}
        handleChange={handleChangeWithTouch}
        errors={errors}
        config={config}
        isValid={isValid}
      />
      <FieldContent>
        <FieldLabel htmlFor={`${id}-input`}>
          {label}
          {required && <span className="ml-0.5 text-red-500">*</span>}
        </FieldLabel>
        {description && <FieldDescription>{description}</FieldDescription>}
        {!isValid && showErrors && <FieldError errors={[{ message: errors }]} />}
      </FieldContent>
    </Field>
  );
};

export const shadcnBooleanToggleControlTester: RankedTester = rankWith(
  3,
  and(isBooleanControl, optionIs("toggle", true)),
);

export const ShadcnBooleanToggleControlContext = withJsonFormsControlProps(
  ShadcnBooleanToggleControl,
);
